import React from 'react'
import get from 'lodash/get'

// eslint-disable-next-line
export default keyOn => WrappedComponent => props => (
  <WrappedComponent key={get(props, keyOn)} {...props} />
)



// WEBPACK FOOTER //
// client/components/sections/website/Leads/key_on.js